import { render, staticRenderFns } from "./AccountOrderHistory.vue?vue&type=template&id=95b1c7e2&"
import script from "./AccountOrderHistory.vue?vue&type=script&lang=js&"
export * from "./AccountOrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports